/* ============
 * Getters for the profile module
 * ============
 *
 * The getters that are available on the
 * profile module.
 */
import { clone } from '@/utils/object';

const getAllGroups = state => clone(state.groups);
const getLoading = state => state.loading;
const getGroupByIdFromState = state => id => {
  return state.groups.find(h => h.id === id);
};

const getGroupUserList = state => clone(state.groupUserInfo);

const getGroupInfo = state => clone(state.getGroupInfo);

export default {
  getAllGroups,
  getLoading,
  getGroupByIdFromState,
  getGroupInfo,
  getGroupUserList,
  isBusy: state => state.isBusy,
  isLoading: state => state.isLoading,
};
